// Importing necessary React components and icons
import { MdOutlineMessage } from "react-icons/md"; // Icon for message
import { PiArrowsLeftRight } from "react-icons/pi"; // Icon for arrow left-right
import CloseButton from 'react-bootstrap/CloseButton'; // Close button from React Bootstrap
import { Link } from 'react-router-dom'; // Link component for routing

// Alert component to display alerts in a table format
function Alert() {
  return (
    // Main container for the alert component
    <div style={{ width: "100%" }}>

      {/* Header section with the title "Alerts" */}
      <div className="row" style={{ backgroundColor: '#004aad', padding:"7px", borderRadius: "8px"}}>
        <div className="col" style={{textAlign:"left", width:"100%"}}>
          {/* Title for the Alerts section */}
          <h2 style={{ color: 'white' }}>Alerts</h2>
        </div>
      </div>

      {/* Table for listing the alerts */}
      <div className="row" style={{ marginTop: "10px" }}>
        <table className="table table-bordered">
          <thead>
            {/* Table headers */}
            <tr>
              <th style={{ backgroundColor: '#f0f0f0', color: '#333' }}>Date </th>
              <th style={{ backgroundColor: '#f0f0f0', color: '#333' }}>Message</th>
              <th style={{ backgroundColor: '#f0f0f0', color: '#333' }}>Assigned User</th>
            </tr>
          </thead>
          <tbody>
            {/* Table row displaying an alert */}
            <tr>
              <td style={{ fontSize: '13px' }}>
                {/* Date and message icon */}
                30 Jul 2024, 18:18:21 <MdOutlineMessage />
                
                {/* Link to the specific internal note */}
                <Link to="/path/to/New Internal note"> New Internal note </Link> 
              </td>
              <td></td> {/* Empty column for message content (can be added later) */}
              
              {/* Assigned user section */}
              <td style={{ fontStyle: 'italic' }}>
                {/* Displaying "None" and an arrow icon */}
                <div style={{display:'flex', gap:'14%'}}>
                  <span>None
                    <PiArrowsLeftRight />
                  </span>

                  {/* Close button for removing the alert */}
                  <CloseButton style={{ fontSize: '12px', padding: '4px'}} />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  );
}

export default Alert;
